import Cookies from 'js-cookie'
import config from '../../assets/config'
const app = {
  state: {
    uploadAddr: config.uploadAddr,
    env: config.env,
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    ispbrCenterClose: 0,
    ispbrTenderFormClose: 0,
    isauctionHallClose: 0,
    isCollapse: false,
    pbrCenterInfo: {
      pbtseq: 0,
      projectid: 0,
      pbrcomid: 0
    },
    printTitle: '南方采购交易平台', // 打印标题
    damid: '',
  },
  mutations: {
    SET_PBRCENTER_INFO: (state, val) => {
      state.pbrCenterInfo = val
    },
    SET_PRINT_TITLE: (state, val) => {
      state.printTitle = val
    },
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_ISPBRCENTERCLOSE: (state, val) => {
      state.ispbrCenterClose = val
    },
    SET_ISPBRTENDERFORMCLOSE: (state, val) => {
      state.ispbrTenderFormClose = val
    },
    SET_ISAUCTIONHALLCLOSE: (state, val) => {
      state.isauctionHallClose = val
    },
    SET_ISCOLLAPSE: (state, val) => {
      state.isCollapse = val
    },
    SET_DAMID: (state, val) => {
      state.damid = val
    }
  },
  actions: {
    toggleSideBar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  }
}

export default app
